<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="location_on" v-model="form.custom.entity_id" :options="locations_select" grouped="1"
            :unselected="lang.polaris.common.no_location">
        </trax-ui-select>

        <trax-ui-input type="text" icon="local_offer" :placeholder="lang.polaris.common.hdv_ref"
            v-model="form.custom.meta.hdv_ref" :error="errors.hdv_ref">
        </trax-ui-input>

        <trax-ui-toggle col="md-3"
            text="HDV sync is required to sign sheets" 
            v-model="form.custom.meta.hdv_sync_required"
        ></trax-ui-toggle>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: null,
            endpoint: null,
            registrationId: null
        },
    
        data: function() {
            return {
                lang: lang,
                form: {
                    custom: {
                        meta: { 
                            hdv_ref: null,
                            hdv_sync_required: 0,
                        }
                    }
                },
                errors: {},
                locations_select: data.locations_select,
                props: {
                    id: { source: 'id' },
                    custom: { source: this.defaultCustom, default: this.defaultCustom },
                    registration_id: { value: this.registrationId },
                },
                titles: {
                    new: lang.polaris.common.new_phase,
                    update: lang.polaris.common.phase_custom
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        },

        methods: {

            defaultCustom(data) {
                let custom = data.custom ? data.custom : {}
                if (!custom.entity_id) {
                    custom.entity_id = data.entity_id
                }
                if (!custom.meta) {
                    custom.meta = { hdv_ref: null, hdv_sync_required: 0 }
                }
                return custom
            }
        }
    }
</script>
